import { Box, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { useProviderPublicMatchingProfile } from '@uplift/queries';
import { Button, Modal, ModalActions, ModalContent } from '@uplift/ui-v2';

export type NoInsuranceModalProps = {
  open: boolean;
  onClose: () => void;
  providerId: string;
};

export const NoInsuranceModal: React.VFC<NoInsuranceModalProps> = ({ open, onClose, providerId }) => {
  const l10n = useL10n();
  const { data: matchingProfile } = useProviderPublicMatchingProfile(providerId);
  const providerName = matchingProfile?.nameDisplay?.full ?? '';

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth="md"
      title={l10n.matching.insurance.modal.title}
    >
      <ModalContent>
        <Box display="flex" flexDirection="column" gap="1rem">
          <Typography>{l10n.matching.insurance.modal.line1(providerName)}</Typography>
          <Typography>{l10n.matching.insurance.modal.line2(providerName)}</Typography>
        </Box>
      </ModalContent>
      <ModalActions>
        <Button variant="contained" color="secondary" onClick={onClose}>
          {l10n.matching.insurance.modal.gotIt}
        </Button>
      </ModalActions>
    </Modal>
  );
};